import {
	getReport,
	getStockReport,
} from '../../services/api/report.api';
import {
	GET_REPORT_REQUEST,
	GET_REPORT_SUCCESS,
	GET_REPORT_FAILURE,
	GET_STOCK_REPORT_REQUEST,
	GET_STOCK_REPORT_SUCCESS,
	GET_STOCK_REPORT_FAILURE,
} from '../types';
import {
	transformReportList,
	transformStockReport,
} from '../../transforms/report';
import { transformPagination } from '../../transforms/pagination';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		report: {
			isLoading: false,
			error: null,
			data: [],
			pagination: transformPagination({}),
		},
		chart: {
			isLoading: false,
			error: null,
			data: transformStockReport({}),
		},
	},

	mutations: {
		[GET_REPORT_REQUEST](state) {
			state.report.isLoading = true;
			state.report.error = null;
			state.report.data = [];
		},
		[GET_REPORT_SUCCESS](state, { data, meta }) {
			state.report.isLoading = false;
			state.report.data = transformReportList(data);
			state.report.pagination = transformPagination(meta);
		},
		[GET_REPORT_FAILURE](state, error) {
			state.report.isLoading = false;
			state.report.error = transformError(error);
		},
		[GET_STOCK_REPORT_REQUEST](state) {
			state.chart.isLoading = true;
			state.chart.error = null;
			state.chart.data = [];
		},
		[GET_STOCK_REPORT_SUCCESS](state, data) {
			state.chart.isLoading = false;
			state.chart.data = transformStockReport(data);
		},
		[GET_STOCK_REPORT_FAILURE](state, error) {
			state.chart.isLoading = false;
			state.chart.error = transformError(error);
		},
	},

	actions: {
		async getReportData({ commit }, _params = {}) {
			const params = {
				'filters[brand_id]': _params.brand,
				'filters[status]': _params.status,
				'filters[product_type]': _params.type,
				'filters[stock_ageing]': _params.stock_ageing,
				'filters[category_id]': _params.category_id,
				keyword: _params.keyword,
				sort_by: _params.sort_by,
				sort_direction: _params.sort_direction,
				page: _params.page,
				per_page: 30,
			};
			try {
				commit(GET_REPORT_REQUEST);
				const { data } = await getReport(params);
				commit(GET_REPORT_SUCCESS, data);
			} catch (error) {
				commit(GET_REPORT_FAILURE, error);
			}
		},
		async getStockReportData({ commit }) {
			try {
				commit(GET_STOCK_REPORT_REQUEST);
				const { data } = await getStockReport();
				commit(GET_STOCK_REPORT_SUCCESS, data);
			} catch (error) {
				commit(GET_STOCK_REPORT_FAILURE, error);
			}
		},
	},
};
